import { PaginatedApiResponse } from 'domain/Common';

import { AsyncSurveyListItem, AsyncSurveyListItemResponse } from '../types';
import { mapSurveyFromApi } from './mapSurveyResponse';

export const mapSurveysListResponse = (
  response: PaginatedApiResponse<AsyncSurveyListItemResponse>
): PaginatedApiResponse<AsyncSurveyListItem> => ({ ...response, data: response.data.map(mapSurveyFromApi) });
